import React, { useState, useEffect } from "react"
// import Plotly from 'plotly.js'
import plotly from './plotlyTools.js';

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $, { data } from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import dash from './dashboardTools.js';
import './nlp/tabler.css';

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object && !isarray(o); }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}


function Charts(prop) {

    function drawCharts() {
        let css = {
            width: '50%',
            background: 'white',
            // padding: 10,
        }
        $('#chart1').css(css);
        $('#chart2').css(css);
        $('#chart3').css(css);
        $('#chart4').css(css);
        $('#chart5').css(css);
        $('#chart6').css(css);
        $('#chart7').css(css);


        // var lcolors = frm.paletteWheel(8, 2)

        // let data1 = {
        //     "values": [
        //         [
        //             3,
        //             4
        //         ],
        //         [
        //             3,
        //             3
        //         ],
        //         [
        //             3,
        //             2
        //         ]
        //     ],
        //     "xLabels": [
        //         [
        //             "Green",
        //             ""
        //         ],
        //         [
        //             "Blue",
        //             ""
        //         ],
        //         [
        //             "Red",
        //             ""
        //         ]
        //     ],
        //     "yLabels": [
        //         "Prediction",
        //         "Ground Truth"
        //     ]
        // }

        // let cfg1 = {
        //     "container": $('#chart1'),
        //     "title": "Label Distribution",
        //     "format": function ival(v) { return Math.floor(val(v)); },
        //     "formatTooltip": function ival(v) { return Math.floor(val(v)); },
        //     "formatTick": function ival(v) { return Math.floor(val(v)); },
        //     "paddingY": 30,
        //     "rotated": true,
        //     "hideY": true
        // }

        // let data2 = {
        //     "values": [
        //         [
        //             4
        //         ],
        //         [
        //             3
        //         ],
        //         [
        //             3
        //         ],
        //         [
        //             1
        //         ]
        //     ],
        //     "xLabels": [
        //         "Name",
        //         "Address",
        //         "Date",
        //         "aaaa"
        //     ],
        //     "yLabels": [
        //         "Label count"
        //     ]
        // };
        // let cfg2 = {
        //     "container": $('#chart2'),
        //     "title": "Label Distribution",
        //     "format": function ival(v) { return v.toFixed(0); },
        //     "formatTooltip": function ival(v) { return v.toFixed(0); },
        //     "formatTick": function ival(v) { return v.toFixed(0); },
        //     "paddingY": 50,
        //     "rotated": true,
        //     "dataColor": function (c, d) { return lcolors[d.x % lcolors.length]; },
        //     "hideLegends": true,
        //     "hideY": true
        // }



        // dash.drawGraphBar(data1, cfg1);
        // dash.drawGraphBar(data2, cfg2);
        
        
        groupBarChart();
        barChart();
        donutChart();
        barChart2();
        barChart3();
        barChart4();
        treeMapChart();
        
    }

    function groupBarChart() {

        let data = {
            xData : [
                {
                    values: [3,3,4],
                    name: 'bar1',
                    color: 'rgb(52, 73, 94)',
                    orientation: 'h',
                },
                {
                    values: [4,3,2],
                    name: 'bar2',
                    color: 'rgb(155, 92, 182)',
                    orientation: 'h',
                }
            ],
            showXlabels: false,
            yValues: ['Red', 'Green', 'Blue'],
            container : $('#chart1')[0]
        }

        let config = {
            barmode: 'group',
            chartTitle: 'Chart1',
            size: {
                height: '700',
                width: '500'
            }
        }

        plotly.drawBarChart(data, config);
    }

    function barChart() {
        var lcolors = frm.paletteWheel(8, 2)


        let data = {
            xData : [
                {
                    values: [3.93333, 3.1234, 4.434634],
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
                }
            ],
            showXlabels: false,
            yValues: ["Name", "Address", "Date", "aaaa"],
            container : $('#chart2')[0]
        }
    
        let config = {
            chartTitle: 'Task States',
            size: {
                height: '600',
                width: '400'
            },
            // barmode: false,
            // dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

        plotly.drawBarChart(data, config);
    }

    function barChart2() {
        var lcolors = frm.paletteWheel(8, 2)


        let data = {
            xData : [
                {
                    values: [262, 264, 285, 293, 378, 460, 472, 481, 1316, 1732, 2129, 2599, 2944, 3087, 5495],
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
                }
            ],
            showXlabels: false,
            yValues: ['PER_M', 'Red', 'Green', 'PER_U', 'RESIDENCE', 'SIBLING', 'B-MISC', 'LOC', 'I-MISC', 'I-LOC', 'B-LOC', 'B-PER', 'B-ORG', 'I-PER', 'I-ORG'],
            yLabel: 'Label count',
            container : $('#chart4')[0]
        }
    
        let config = {
            chartTitle: 'Top Labels',
            size: {
                height: '700',
                width: '600'
            },
            // barmode: false,
            dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

        plotly.drawBarChart(data, config);
    }

    function barChart3() {
        var lcolors = frm.paletteWheel(8, 2)


        let data = {
            xData : [
                {
                    values: [6, 23, 4, 14, 2299, 50, 26, 8, 13, 12, 59, 63, 42, 15, 29],
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
                }
            ],
            showXaxis: true,
            showXlabels: true,
            yValues: ['Transcription_training_Video_test', 'Test_Prelabeling_new', 'NER TXT Import', 'Test NER Txt', 'Bulk_Image_Classification_3', 'Test_Prelabeling', 'Transcription_Test', 'transcription test', 'NER TXT WITH Annotations', 'TT', 'Test_Prelabeling_2', 'Test_Custom_Prelabeling', 'NER-BMS-TEST', 'Hi', 'Test_Custom_Prelabeling_V2'],
            yLabel: 'Tasks',
            container : $('#chart5')[0]
        }
    
        let config = {
            chartTitle: 'Tasks by Project',
            size: {
                height: '700',
                width: '600'
            },
            // barmode: false,
            dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

        plotly.drawBarChart(data, config);
    }

    function barChart4() {
        var lcolors = frm.paletteWheel(8, 2)


        let data = {
            xData : [
                {
                    values: [0, 13.043478260869565, 0, 0, 52.76207046541975, 2, 7.6923076923076925, 12.5, 23.076923076923077, 0, 0, 3.1746031746031744, 21.428571428571427, 20, 24.137931034482758],
                    // name: 'bar1',
                    color: function (c, d) { return lcolors[d % lcolors.length] },
                    orientation: 'h',
                    unit: '%',
                    texttemplate: "%{x:.1f}",
                }
            ],
            showXaxis: true,
            showXlabels: true,
            yValues: ['Transcription_training_Video_test', 'Test_Prelabeling_new', 'NER TXT Import', 'Test NER Txt', 'Bulk_Image_Classification_3', 'Test_Prelabeling', 'Transcription_Test', 'transcription test', 'NER TXT WITH Annotations', 'TT', 'Test_Prelabeling_2', 'Test_Custom_Prelabeling', 'NER-BMS-TEST', 'Hi', 'Test_Custom_Prelabeling_V2'],
            yLabel: 'Tasks',
            container : $('#chart6')[0]
        }
    
        let config = {
            chartTitle: 'Project Status',
            size: {
                height: '700',
                width: '600'
            },
            // barmode: false,
            dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

        plotly.drawBarChart(data, config);
    }

    function donutChart() {

        let data = {
            xData : [
                {
                    values: [ 1156, 216, 26, 19, 1240, 1, 3, 1, 1 ],
                    domain: {column: 0},
                    name: 'Donut 1',
                }
            ],
            labels: [
                "Unassigned",
                "In Progress",
                "Submitted for Review",
                "In review",
                "Approved",
                "Rejected",
                "Submitted",
                "Declined",
                "Processing Error"
            ],
            container : $('#chart3')[0],
            grid : { rows: 1, columns: 1}
        }
    
        let config = {
            chartTitle: 'Task States',
            size: {
                height: '600',
                width: '600'
            },
        }

        plotly.drawDonutChart(data, config);
    }

    function heatMap() {
        let data = {
            xData : [
                {
                    values: [ 1156, 216, 26, 19, 1240, 1, 3, 1, 1 ],
                    domain: {column: 0},
                    name: 'Donut 1',
                }
            ],
            labels: [
                "Unassigned",
                "In Progress",
                "Submitted for Review",
                "In review",
                "Approved",
                "Rejected",
                "Submitted",
                "Declined",
                "Processing Error"
            ],
            container : $('#chart3')[0],
            grid : { rows: 1, columns: 1}
        }
    
        let config = {
            chartTitle: 'Task States',
            size: {
                height: '600',
                width: '600'
            },
        }

        plotly.drawHeatMap(data, config);
    }

    function treeMapChart() {
        var lcolors = frm.paletteWheel(8, 2)

        let data = {
            1 : 1,
            container : $('#chart6')[0]
        }
    
        let config = {
            chartTitle: 'Project Status',
            size: {
                height: '700',
                width: '600'
            },
            // barmode: false,
            dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
        }

        plotly.drawTreeMapChart(data, config)
    }

    useEffect(drawCharts);
    return (
        <div fluid="md p-0" className="maincontent" style={{display: 'grid', gridTemplateColumns: 'auto auto', backgroundColor: 'white'}}>
            <div id="chart1"></div>
            <div id="chart2"></div>
            <div id="chart3"></div>
            <div id="chart4"></div>
            <div id="chart5"></div>
            <div id="chart6"></div>
            <div id="chart7"></div>
        </div>
    )
}

export default Charts
